import { IRichTextBoxItemBean } from "../../../infrastructure/document/ver2/beans/items";
import { RichTextBoxInputMethodKinds } from "../inputMethodKinds";
import { RelationalActionKinds } from "..";

export type RichTextBoxInputMethodOptionKinds
  = "Normal"           // 通常
  | "MKSTemplate"      // MKSテンプレート
  | "DynamicTemplate"; // DYNAMICテンプレート

const deciders: { [K in RichTextBoxInputMethodOptionKinds]: (bean: IRichTextBoxItemBean) => boolean } = {
  Normal:          undefined, // otherwiseで返すので定義しない
  MKSTemplate:     bean => (bean.relationalItems && !!bean.relationalItems.find(i => i.relationalActionType === RelationalActionKinds.MksTemplateFormat)),
  DynamicTemplate: bean => (bean.relationalItems && !!bean.relationalItems.find(i => i.relationalActionType === RelationalActionKinds.DynamicTemplateFormat)),
};

const defaultInputMethodKinds: { [K in RichTextBoxInputMethodOptionKinds]: RichTextBoxInputMethodKinds } = {
  Normal:          RichTextBoxInputMethodKinds.None,
  MKSTemplate:     RichTextBoxInputMethodKinds.MKSTemplate,
  DynamicTemplate: RichTextBoxInputMethodKinds.DynamicTemplate,
};

const hasDictionaryProperty = (key: string): key is RichTextBoxInputMethodOptionKinds => deciders.hasOwnProperty(key);

export namespace RichTextBoxInputMethodOptionKinds {
  export const Normal: RichTextBoxInputMethodOptionKinds = "Normal";
  export const MKSTemplate: RichTextBoxInputMethodOptionKinds = "MKSTemplate";
  export const DynamicTemplate: RichTextBoxInputMethodOptionKinds = "DynamicTemplate";

  export const toInputMethodOptionKinds = (bean: IRichTextBoxItemBean): RichTextBoxInputMethodOptionKinds => {
    for (const key in deciders) {
      if (hasDictionaryProperty(key) && deciders[key] != null && deciders[key](bean)) {
        return key;
      }
    }
    return Normal;
  };

  export const getDefualtInputMethodKind = (optionKind: RichTextBoxInputMethodOptionKinds): RichTextBoxInputMethodKinds => {
    return defaultInputMethodKinds[optionKind];
  };
}
